import React, { FC, memo, useCallback, useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { HintTooltip, useBreakpoint, useToasts } from '@brg/ui'
import { IconWrapperSpecial2 } from 'shared/assets/styles';
import { ReactComponent as RepostIcon } from './Repost.svg';
import { ReactComponent as RepostMove } from './Move.svg';
import { useProfile } from '@brg/auth';
import { BookmarkButtonWrapper } from '../bookmarkButtonOnProject/styles';
import styled, { css, useTheme } from 'styled-components';
import { LayoutConst, useModal } from 'core';
import { getTooltipStyles, tooptipStylesWhite } from 'shared/constants/tooptipStyles';
import { AppTester } from 'supporting';
import { Project } from '@brg/api';
import { getFindTab, REPOST_MODE } from 'shared/modals/repostModal/const';
import { useRouteMatch } from 'react-router-dom';
import { useChannelsContext } from 'shared/contexts/ChannelsContext';
import { SP_VOTE_COLLECTION_SIGN } from 'shared/pages/VotesAdmin/VotesAdminPage';

export const RepostButtonWrapper = styled(BookmarkButtonWrapper)<{
  isProjectPage?: boolean
  type?: boolean,
  isReposted?: boolean
  isCollectionVote?: boolean
}>`

    z-index: 11;
    // position: absolute;
    // right: 65px;
    // top: 10px;
    padding: 4px 8px;
    background: rgba(24, 26, 28, 0.5);
    backdrop-filter: blur(2px);
    border-radius: 4px;

      path {
        fill: #fff;
      }

    // ${({ isReposted }) => isReposted && css`
    //   min-height: 34px;
    //   path {
    //     fill: #909090;
    //   }
    // `};

    ${({ isCollectionVote }) => isCollectionVote && css`
      display: none;
    `};

  ${p => !p.isProjectPage && css`
      @media (max-width: ${LayoutConst.screen.s - 1}px) {
          right: 46px;
          top: 8px;
          padding: 4px 6px;

          svg {
              // position: relative;
              // top: -2px;
              width: 16px;
              height: 16px;
          }
      }
  `}
`

type PropsT = {
  project: Project<'Local' | 'Global'>;
  inActiveState?: boolean;
  iconOnPage?: boolean;
  repostProps?: any;
  onUpdate?: (value?: any) => void;
};

const RepostButton: FC<PropsT> = ({ 
  project, 
  inActiveState, 
  iconOnPage = false, 
  onUpdate 
}) => {
  const { t } = useTranslation();
  const toasts = useToasts();
  const profile = useProfile();
  const theme = useTheme();
  const modal = useModal();
  const isSuperPuper = AppTester.isSuperPuper();
  const isGeo = AppTester.isGeograffee();
  const isGeoDafes = AppTester.isGeoDafes();
  const onWhiteBg = !isGeo && !isSuperPuper;
  const [localReposted, setLocalReposted] = useState(false);
  const isCollectionVote = project?.contexts?.includes(SP_VOTE_COLLECTION_SIGN)

  const is993 = useBreakpoint(993)

  const isFeedPage = useRouteMatch('/feed');

  const { 
    channels, 
  } = useChannelsContext();

  const computeChannels = useMemo(
      () => channels?.filter(
          (channel) => channel?.ownersIDs?.includes(profile?.accountId ?? ''))
  , [profile, channels])

  const computeId = useMemo(() => {
    return project?.isBook ? project?.bookId : project?.projectId
  } , [project])

  useEffect(() => {
    const hasTab = !!getFindTab(computeChannels || [], computeId);
    if (!!project?.isInSub || hasTab) {
      setLocalReposted(true)
    }
  } , [project, channels, computeId])

  const handleClick = useCallback(() => {
    if (inActiveState) return null;
    if (!profile?.accountId) {
      toasts.error(t('NEED_AUTHORIZATION'));
      return;
    }

    modal.show('repost-into-channel', {
      projectId: project?.projectId || project?.bookId,
      callBack: (flag: boolean) => {
        setLocalReposted(flag)

        if (isFeedPage) {
          window.location.reload()
        }
      },
      ...(localReposted ? { mode: REPOST_MODE.edit } : {})
    })

  }, [ t, onUpdate, toasts, project, localReposted, inActiveState, profile]);

  const repostIcon = useMemo(() => {
    return localReposted ? <RepostMove /> : <RepostIcon />
  } , [localReposted])

  if (iconOnPage) {
    return (
      <>
        {localReposted ? (            
          <RepostButtonWrapper isReposted onClick={handleClick}>
              <HintTooltip 
                customStyle={isGeoDafes || onWhiteBg ? tooptipStylesWhite : getTooltipStyles(theme)} 
                text={t("hints.reposted_project")} 
                z={999} 
                noDisappearDelay 
                onWhiteBg={onWhiteBg} 
                noArrow
                positionY='bottom'
              >
                {repostIcon}
              </HintTooltip>
            </RepostButtonWrapper>
        ) : (
          <RepostButtonWrapper isCollectionVote={isCollectionVote} onClick={handleClick}>
            <HintTooltip 
                customStyle={isGeoDafes || onWhiteBg ? tooptipStylesWhite : getTooltipStyles(theme)} 
                text={t("hints.repost")} 
                z={999} 
                noDisappearDelay 
                onWhiteBg={onWhiteBg} 
                noArrow
                closeToRightCorner
                positionY={is993? 'bottom' : 'default'}
              >

              {repostIcon}
            </HintTooltip>
          </RepostButtonWrapper>
        )}
      </>
    )
  }

  return (
  <>
    {localReposted ? (            
      <IconWrapperSpecial2 onClick={handleClick}>
        <HintTooltip 
          customStyle={isGeoDafes || onWhiteBg ? tooptipStylesWhite : getTooltipStyles(theme)} text={t("hints.reposted_project")} 
          z={999} 
          noDisappearDelay 
          onWhiteBg={onWhiteBg} 
          noArrow
        >
          {repostIcon}
        </HintTooltip>
      </IconWrapperSpecial2>
    ) : (
      <IconWrapperSpecial2
        fullFill
        onClick={handleClick}
      >
        <HintTooltip 
          customStyle={isGeoDafes || onWhiteBg ? tooptipStylesWhite : getTooltipStyles(theme)} 
          text={t("hints.repost")} 
          z={999} 
          noDisappearDelay 
          onWhiteBg={onWhiteBg} 
          noArrow
        >

          {repostIcon}
        </HintTooltip>
      </IconWrapperSpecial2>   
    )}
  </>
  )
};

export default memo(RepostButton)

import React, { FC, memo, useCallback, useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { HintTooltip, useBreakpoint, useToasts } from '@brg/ui'
import { IconWrapperSpecial2 } from 'shared/assets/styles';
import { ReactComponent as RepostIcon } from './Repost.svg';
import { ReactComponent as RepostMove } from './Move.svg';
import { useProfile } from '@brg/auth';
import { BookmarkButtonWrapper } from '../bookmarkButtonOnProject/styles';
import styled, { css, useTheme } from 'styled-components';
import { LayoutConst, useModal } from 'core';
import { getTooltipStyles, tooptipStylesWhite } from 'shared/constants/tooptipStyles';
import { AppTester } from 'supporting';
import { Project } from '@brg/api';
import { getFindTab, REPOST_MODE } from 'shared/modals/repostModal/const';
import { useRouteMatch } from 'react-router-dom';
import { useChannelsContext } from 'shared/contexts/ChannelsContext';
import { SP_VOTE_COLLECTION_SIGN } from 'shared/pages/VotesAdmin/VotesAdminPage';

export const RepostButtonWrapper = styled(BookmarkButtonWrapper)<{
  isProjectPage?: boolean
  type?: boolean,
  isReposted?: boolean
  isCollectionVote?: boolean
}>`

    z-index: 11;
    // position: absolute;
    // right: 65px;
    // top: 10px;
    padding: 4px 8px;
    background: rgba(24, 26, 28, 0.5);
    backdrop-filter: blur(2px);
    border-radius: 4px;

      path {
        fill: #fff;
      }

    // ${({ isReposted }) => isReposted && css`
    //   min-height: 34px;
    //   path {
    //     fill: #909090;
    //   }
    // `};

    ${({ isCollectionVote }) => isCollectionVote && css`
      display: none;
    `};

  ${p => !p.isProjectPage && css`
      @media (max-width: ${LayoutConst.screen.s - 1}px) {
          right: 46px;
          top: 8px;
          padding: 4px 6px;

          svg {
              // position: relative;
              // top: -2px;
              width: 16px;
              height: 16px;
          }
      }
  `}
`

type PropsT = {
  project: Project<'Local' | 'Global'>;
  inActiveState?: boolean;
  iconOnPage?: boolean;
  repostProps?: any;
  onUpdate?: (value?: any) => void;
};

const RepostButton: FC<PropsT> = ({ 
  project, 
  inActiveState, 
  iconOnPage = false, 
  onUpdate 
}) => {
  const { t } = useTranslation();
  const toasts = useToasts();
  const profile = useProfile();
  const theme = useTheme();
  const modal = useModal();
  const isSuperPuper = AppTester.isSuperPuper();
  const isGeo = AppTester.isGeograffee();
  const isGeoDafes = AppTester.isGeoDafes();
  const onWhiteBg = !isGeo && !isSuperPuper;
  const [localReposted, setLocalReposted] = useState(false);
  const isCollectionVote = project?.contexts?.includes(SP_VOTE_COLLECTION_SIGN)

  const is993 = useBreakpoint(993)

  const isFeedPage = useRouteMatch('/feed');

  const { 
    channels, 
  } = useChannelsContext();

  const computeChannels = useMemo(
      () => channels?.filter(
          (channel) => channel?.ownersIDs?.includes(profile?.accountId ?? ''))
  , [profile, channels])

  const computeId = useMemo(() => {
    return project?.isBook ? project?.bookId : project?.projectId
  } , [project])

  useEffect(() => {
    const hasTab = !!getFindTab(computeChannels || [], computeId);
    if (!!project?.isInSub || hasTab) {
      setLocalReposted(true)
    }
  } , [project, channels, computeId])

  const handleClick = useCallback(() => {
    if (inActiveState) return null;
    if (!profile?.accountId) {
      toasts.error(t('NEED_AUTHORIZATION'));
      return;
    }

    modal.show('repost-into-channel', {
      projectId: project?.projectId || project?.bookId,
      callBack: (flag: boolean) => {
        setLocalReposted(flag)

        if (isFeedPage) {
          window.location.reload()
        }
      },
      ...(localReposted ? { mode: REPOST_MODE.edit } : {})
    })

  }, [ t, onUpdate, toasts, project, localReposted, inActiveState, profile]);

  const repostIcon = useMemo(() => {
    return localReposted ? <RepostMove /> : <RepostIcon />
  } , [localReposted])

  if (iconOnPage) {
    return (
      <>
        {localReposted ? (            
          <RepostButtonWrapper isReposted onClick={handleClick}>
              <HintTooltip 
                customStyle={isGeoDafes || onWhiteBg ? tooptipStylesWhite : getTooltipStyles(theme)} 
                text={t("hints.reposted_project")} 
                z={999} 
                noDisappearDelay 
                onWhiteBg={onWhiteBg} 
                noArrow
                positionY='bottom'
              >
                {repostIcon}
              </HintTooltip>
            </RepostButtonWrapper>
        ) : (
          <RepostButtonWrapper isCollectionVote={isCollectionVote} onClick={handleClick}>
            <HintTooltip 
                customStyle={isGeoDafes || onWhiteBg ? tooptipStylesWhite : getTooltipStyles(theme)} 
                text={t("hints.repost")} 
                z={999} 
                noDisappearDelay 
                onWhiteBg={onWhiteBg} 
                noArrow
                closeToRightCorner
                positionY={is993? 'bottom' : 'default'}
              >

              {repostIcon}
            </HintTooltip>
          </RepostButtonWrapper>
        )}
      </>
    )
  }

  return (
  <>
    {localReposted ? (            
      <IconWrapperSpecial2 onClick={handleClick}>
        <HintTooltip 
          customStyle={isGeoDafes || onWhiteBg ? tooptipStylesWhite : getTooltipStyles(theme)} text={t("hints.reposted_project")} 
          z={999} 
          noDisappearDelay 
          onWhiteBg={onWhiteBg} 
          noArrow
        >
          {repostIcon}
        </HintTooltip>
      </IconWrapperSpecial2>
    ) : (
      <IconWrapperSpecial2
        fullFill
        onClick={handleClick}
      >
        <HintTooltip 
          customStyle={isGeoDafes || onWhiteBg ? tooptipStylesWhite : getTooltipStyles(theme)} 
          text={t("hints.repost")} 
          z={999} 
          noDisappearDelay 
          onWhiteBg={onWhiteBg} 
          noArrow
        >

          {repostIcon}
        </HintTooltip>
      </IconWrapperSpecial2>   
    )}
  </>
  )
};

export default memo(RepostButton)

